// extracted by mini-css-extract-plugin
module.exports = {"GridItem":"styles_GridItem__17MuR","imageContainer":"styles_imageContainer__1WPLe","image":"styles_image__1rr-I","title":"styles_title__2rVPz"};